import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.scss']
})
export class LoginLayoutComponent implements OnInit {

  showHeader = true;
  showUserInfo = true;
  bgImageUrl: string = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        startWith(null),
        map(() => {
          let route = this.activatedRoute;

          while (route.firstChild) {
            route = route.firstChild;
          }

          return route.snapshot.data;
        })
      )
      .subscribe(data => {
        this.showHeader = data['showHeader'] !== undefined ? data['showHeader'] : true;
        this.showUserInfo = data['showUserInfo'] !== undefined ? data['showUserInfo'] : true;
      });
    }

  setBackgroundUrl(url: string) {
    this.bgImageUrl = url ? `url(${url})` : null;
  }
}
